module.exports = __webpack_public_path__ + "img/bentoboxfrontalmithintergrund.f9a13ac7.jpg";